<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row ----------------------------------- -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="third" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row ----------------------------------- -->


            <!-- >>> 'Overview' - Row -------------------------------------- -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;">
                        <span class="index">
                            <i class="soap-icon-arrow-right circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>

                <!-- >>>  Left Side: : 'Overview' -->
                <form @submit.prevent="onSubmit">
                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">
                        <!-- >>> Booking Details -->
                        <div id="flight-features" class="tab-container">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs">
                                <li class="active">
                                    <a
                                        href="#flight-details"
                                        data-toggle="tab"
                                    >{{ tab_flightdetails[getCurrentLocale] }}</a>
                                </li>
                                <!-- <li><a href="#inflight-features" data-toggle="tab">{{ tab_inflightfeatures[getCurrentLocale] }}</a></li> -->
                            </ul>
                            <!-- <<< TabHeader:  -->

                            <!-- >>> Tab Content: -->
                            <div class="tab-content">
                                <!-- --------------------------------------- -->
                                <!-- >>> Tab: 'flight-details' -->
                                <div class="tab-pane fade in active" id="flight-details">
                                    <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->
                                    <sdr-flight-details flightdirection="outward" mode="direct" :datatocatch="getBookingCart" :modulo="modulo"></sdr-flight-details>
                                    <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->

                                    <!-- >>> 'Return Flight' Part -->
                                    <div v-if="getBookingFlightIdSelectedReturn !== null">
                                        <br />
                                        <hr />
                                        <br />
                                        <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                        <sdr-flight-details flightdirection="return" mode="direct" :datatocatch="getBookingCart" :modulo="modulo"></sdr-flight-details>
                                        <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                    </div>
                                    <!-- <<< 'Return Flight' Part -->

                                    <!-- >>> Total::Total::Total -->

                                    <!-- <<< Total::Total::Total -->
                                </div>
                                <!-- <<< Tab: 'flight-details' -->
                                <!-- --------------------------------------- -->
                            </div>
                            <!-- <<< Tab Content: -->
                        </div>
                        <!-- <<< Booking Details -->

                        <br />
                        <!-- >>> Payment Details -->

                        <!-- <<< Payment Details -->

                        <!-- >>> Confirm CheckBoxes -->

                        <!-- <<< Confirm CheckBoxes -->

                        <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }">{{ proceed[getCurrentLocale] }}</button>
                    </div>
                </form>
                <!-- <<<  Left Side: : 'Overview' -->



                <!-- >>>  Right Side: Sidebar, 'Overview' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Overview' -->
            </div>
            <!-- <<< 'Overview' - Row -------------------------------------- -->
        </div>
    </section>
</template>

<script>
    import FlightDetails from '../../booking/overview/FlightDetails.vue';

    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import SharedCart from '../../shared/cart/Cart.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-flight-details': FlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-shared-cart': SharedCart,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> --------------------------
                form: {
                    pax: [
                        {
                            id_pax: '',
                            outward_srvcs:[
                                {
                                    id: '',
                                    price: 0,
                                }
                            ],
                            return_srvcs: [
                                {
                                    id: '',
                                    price: 0,
                                }
                            ]
                        }
                    ]
                },
                // >>> --------------------------
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_pcp: {
                    en: 'Dangerous goods',
                    de: 'Gefährliche Gegenstände',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                pleaseselectoverview: {
                    en: 'Step 3: Please set your prices.',
                    de: 'Schritt 3: Bitte legen Sie Ihre Preise fest.'
                },
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückflug'
                },
                tab_flightdetails: {
                    en: 'Your booking overview',
                    de: 'Ihre Buchungsübersicht'
                },
                tab_inflightfeatures: {
                    en: 'Inflight Features',
                    de: 'Funktionen an Bord'
                },
                tab_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck'
                },
                tab_farerules: {
                    en: 'Fare Rules',
                    de: 'Tarifbestimmungen'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                tab_header_flightdetails: {
                    en: 'Your flight and booking details for the outbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for the inbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
                },
                tab_header_inflightfeatures: {
                    en: 'For your well-being on board',
                    de: 'Für Ihr Wohlbefinden an Bord'
                },
                tab_header_farerulesforyourflight: {
                    en: 'Fare Rules for your Flight',
                    de: 'Tarifregeln für Ihren Flug'
                },
                // >>> --------------------------
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                seatsandbaggage: {
                    en: 'Seats & Baggage',
                    de: 'Sitze & Gepäck',
                },
                extracharge: {
                    en: 'Extra Charge',
                    de: 'Aufpreis'
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                form_confirmabb_1 : {
                    en: 'By continuing, you agree to the Terms and Conditions.',
                    de: 'Ich habe die ABBs gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmagb_1 : {
                    en: 'I confirm that I am 18 years or older and I have read and agree to the General Terms.',
                    de: 'Ich bestätige, dass ich 18 Jahre oder älter bin und ich habe die AGB gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmdangerous_1 : {
                    en: 'I have read the information on the carriage of dangerous goods and agree to it.',
                    de: 'Ich habe die Informationen zur Beförderung gefährlicher Gegenstände gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmprivacy_1 : {
                    en: 'I have read the privacy policy and agree to it.',
                    de: 'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmadditional_1 : {
                    en: 'I have noted the charges for additional services and agree to it.',
                    de: 'Ich habe die Entgelte für Zusatzleistungen zur Kenntnis genommen und erkläre mich damit einverstanden.',
                },
                pleaseclickallcheckboxes : {
                    en: 'Please confirm all Checkboxes.',
                    de: 'Bitte bestätigen sie alle Checkboxen.',
                },
                // >>> --------------------------
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },
                cashpayment: {
                    en: 'Cash',
                    de: 'Barzahlung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'EMAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                // >>> --------------------------
                pleaseconfirm: {
                    en: 'Please confirm',
                    de: 'Bitte bestätigen Sie',
                },
                flightprice : {
                    en: 'Flight price',
                    de: 'Flugpreis',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                total : {
                    en: 'Total',
                    de: 'Gesamt',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                // >>> --------------------------
                inflightfeatures_wifi: {
                    en: 'WI_FI',
                    de: 'WI_FI',
                },
                inflightfeatures_entertainment: {
                    en: 'Entertainment',
                    de: 'Entertainment',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_airconditioning: {
                    en: 'Air conditioning',
                    de: 'Klimatisierung',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_games: {
                    en: 'Games',
                    de: 'Spiele',
                },
                inflightfeatures_coffee: {
                    en: 'coffee',
                    de: 'Kaffee',
                },
                inflightfeatures_wines: {
                    en: 'Wines',
                    de: 'Weine',
                },
                inflightfeatures_shopping: {
                    en: 'Shopping',
                    de: 'Shopping',
                },
                inflightfeatures_food: {
                    en: 'Food',
                    de: 'Essen',
                },
                inflightfeatures_comfort: {
                    en: 'Comfort',
                    de: 'Komfort',
                },
                inflightfeatures_magazines: {
                    en: 'Magazines',
                    de: 'Zeitschriften',
                },
                agencycommision: {
                    en: 'Your agency commision is: ',
                    de: 'Ihre Agentur-Provision ist: ',
                },
                // >>> --------------------------
                inthissection: {
                    en: "In this section you'll find information on baggage allowances, special equipment and sports items as well as restricted items. We've also included some tips to make your trip more enjoyable.",
                    de: 'In diesem Abschnitt finden Sie Informationen über Freigepäck, Sonderausstattungen und Sportartikel sowie eingeschränkte Gegenstände. Wir haben auch einige Tipps beigefügt, um Ihre Reise noch angenehmer zu gestalten.',
                },
                // >>> --------------------------
                proceed: {
                    en: 'PROCEED TO PAYMENT INFORMATION', // BOOK WITH OBLIGATION TO PAY
                    de: 'WEITER ZU ZAHLUNGSDETAILS', // ZAHLUNGSPFLICHTIG BUCHEN
                },
                threedsecurecancelled: {
                    en: '3D Secure Proceedure canceled.',
                    de: '3D Secure Vorgang abgebrochen.',
                },
                // >>> -------------------------- Modal WireCard
                AcsUrl: null,
                PaReq: null,
                TermUrl: null,
                OutputFrameSrc: null,

                // >>> -------------------------- Modal

                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
                // >>> --------------------------
                checkedBoxes: [],
                // >>> --------------------------
                bankaccount_holder: null,
                bankaccount_no: null,
                bankaccount_bankno: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingOverviewIsReadyForProcess',
                'getBookingProcessBookingObject',
                'getBookingFlightIdSelectedReturn', // got RET Flight?

                // >>> --------------------------
                'getServicesProcessBookingObject', // object fpr process booking
                'getFlagSharedAgencyLoggedIn', // Agency
                'getSharedAgencyLoginResultsAmountAndValue', // Agency (Parts)
                // >>> --------------------------
                'getBookingWireCardEnrollPaymentResults',

                // >>> --------------------------
                'get_areWeInServicesGroupbookingMode',

                'getBookingCart', // Pax per Pax
                'getServicesValidatePassengersObject',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingsconfirmation' ('Call(s) done ...').
        * Note: Catch Event 'messsage' from iFrame here too.
        *
        */
		created: function () {

            let me = this;



        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function () {

            let me = this;




        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> booking/overview/Ownprices.vue >>> beforeDestroy');


        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setServicesValidatePassengersObject',
                'actn_setBooking_RebuildTotalsFromCartForDirect', // rebuild afer 'price self input'
                'actn_setBooking_RebuildTotalsFromCartForZeroBooking', // rebuild for zero booking
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_ZeroBooking()
            *
            * Desc: 'Overview Form' gets (not really) submitted.
            * Desc:

            *
            * @param {Object} submitEvent (Event)
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    validatePassengerObjectClone = { ...this.getServicesValidatePassengersObject },
                    options = {
                        container: 'body',
                        easing: 'linear',
                        offset: -60,
                        force: true,
                        cancelable: true,
                        onStart: function(element) {
                            // scrolling started
                        },
                        onDone: function(element) {
                            // scrolling is done
                        },
                        onCancel: function() {
                            // scrolling has been interrupted
                        },
                        x: false,
                        y: true
                    };


                me.$toc('>>> booking/ownprices/Ownprices.vue >>> onSubmit');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {

                    me.$router.push({ path: '/payment/' + me.modulo  });

                    setTimeout(function() {
                        me.$scrollTo('#scrollPointTop', 200, options);
                    }, 300);

                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {

                    // >>> Update Services ----------------
                    validatePassengerObjectClone.passengers.forEach((pax, index) => {
                        pax.services = this.buildValidateParams_Srvcs(index + 1);
                        pax.seatServices = this.buildValidateParams_Seats(index + 1);
                    });

                    this.actn_setServicesValidatePassengersObject(validatePassengerObjectClone); // Save/Update Validate Object...
                    this.actn_setBooking_RebuildTotalsFromCartForDirect();


                    // >>> Walk on ------------------------
                    me.$router.push({ path: '/payment/' + me.modulo  });
                    setTimeout(function() {
                        me.$scrollTo('#scrollPointTop', 200, options);
                    }, 300);

                }

            }, // eof onSubmit()




            /*******************************************************************
            *
            *******************************************************************/
            /*******************************************************************
            * buildValidateParams_Srvcs()
            *
            * Desc: Build 'services' Array for 'validatePassengers' Params.
            * Note:
            * Note: NEW (03.2020), Add older Bookingno Srvcs too here!
            * Note: Pay Attention: SEAT does not belong into services[] !
            *
            * @param {Int} id_pax ()
            * @return {Array} services
            */
            buildValidateParams_Srvcs: function(id_pax) {

                let me = this,
                    services = [];


                me.$toc('>>> booking/ownprices/Ownprices.vue >>> buildValidateParams_Srvcs');
                // >>> Searching 'Cart' --------- a)
                for (var i = 0; i < this.getBookingCart.length; i++) {
                    if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {
                        for (var a = 0; a < this.getBookingCart[i].outward_srvcs.length; a++) {
                            services.push({
                                price: +this.getBookingCart[i].outward_srvcs[a].price, // directbooking
                                tktClass: 'Y', // directbooking
                                code: this.getBookingCart[i].outward_srvcs[a].code,
                                comment: this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Comment,
                                idFlight: this.getBookingFlightIdSelectedOutward,
                                quantity: parseFloat(this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Count, 10),
                            });
                        }

                        for (var b = 0; b < this.getBookingCart[i].return_srvcs.length; b++) {
                            services.push({
                                price: +this.getBookingCart[i].return_srvcs[b].price, // directbooking
                                tktClass: 'Y', // directbooking
                                code: this.getBookingCart[i].return_srvcs[b].code,
                                comment: this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Comment,
                                idFlight: this.getBookingFlightIdSelectedReturn,
                                quantity: parseFloat(this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Count, 10),
                            });
                        }
                    }
                }


                return services;

            }, // eof buildValidateParams_Srvcs()


            /*******************************************************************
            * buildValidateParams_Seats()
            *
            * Desc: Build 'seats' Array for 'validatePassengers' Params.
            * Note:
            *
            * @param {Int} id_pax ()
            * @return {Array} seats
            */
            buildValidateParams_Seats: function(id_pax) {

                let me = this,
                    services = [];


                me.$toc('>>> booking/ownprices/Ownprices.vue >>> buildValidateParams_Seats');
                // >>> Searching 'Cart' --------- a)
                for (var i = 0; i < this.getBookingCart.length; i++) {
                    if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {

                        if (this.getBookingCart[i].outward_seat.price !== undefined) {
                            services.push({
                                price: this.getBookingCart[i].outward_seat.price, // directbooking
                                code: this.getBookingCart[i].outward_seat.code,
                                comment: this.getBookingCart[i].outward_seat.comment,
                                idFlight: this.getBookingCart[i].outward_seat.id_flight,
                                quantity: this.getBookingCart[i].outward_seat.quantity,
                                tktClass: this.getBookingCart[i].outward_seat.tktClass,
                                infantOnLap: this.getBookingCart[i].outward_seat.infantOnLap,
                                lockingCode: this.getBookingCart[i].outward_seat.lockingcode,
                                seatName: this.getBookingCart[i].outward_seat.seatno,
                            });
                        }

                        if (this.getBookingCart[i].return_seat.price !== undefined) {
                            services.push({
                                price: this.getBookingCart[i].return_seat.price, // directbooking
                                code: this.getBookingCart[i].return_seat.code,
                                comment: this.getBookingCart[i].return_seat.comment,
                                idFlight: this.getBookingCart[i].return_seat.id_flight,
                                quantity: this.getBookingCart[i].return_seat.quantity,
                                tktClass: this.getBookingCart[i].return_seat.tktClass,
                                infantOnLap: this.getBookingCart[i].return_seat.infantOnLap,
                                lockingCode: this.getBookingCart[i].return_seat.lockingcode,
                                seatName: this.getBookingCart[i].return_seat.seatno,
                            });
                        }
                    }
                }


                return services;

            }, // eof buildValidateParams_Seats()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active,
    #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    /* Modal */
    .size-modal2-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal='size-modal2'] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #f7f7f7;
        box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }



    /* a {
            color: rgb(119, 41, 85);
        } */

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>
